import React from 'react';

import { IOutgrowFields } from '@/types/contentful';

import InPage from './InPage';
import Popup from './Popup';
import Chat from './Chat';
import FloatingRectangle from './FloatingRectangle';
import GreetBar from './GreetBar';
import Sidenote from './Sidenote';
import OutgrowIframe from './OutgrowIframe';

export enum outgrowEnum {
  IN_PAGE = 'In Page',
  POPUP = 'Popup',
  CHAT = 'Chat',
  GREET_BAR = 'Greet Bar',
  FLOATING_RECTANGLE = 'Floating Rectangle',
  SIDENOTE = 'Sidenote',
  CUSTOM = 'Custom Embed',
  ARTICLE = 'Instant Article'
}

interface OutgrowProps extends Partial<Omit<IOutgrowFields, 'embedType'>> {
  embedType: outgrowEnum | IOutgrowFields['embedType'];
}

export function Outgrow({ embedType, ...fields }: OutgrowProps) {
  switch (embedType) {
    case outgrowEnum.IN_PAGE:
      return <InPage {...fields} />;

    case outgrowEnum.POPUP:
      return <Popup {...fields} />;

    case outgrowEnum.CHAT:
      return <Chat {...fields} />;

    case outgrowEnum.FLOATING_RECTANGLE:
      return <FloatingRectangle {...fields} />;

    case outgrowEnum.GREET_BAR:
      return <GreetBar {...fields} />;

    case outgrowEnum.SIDENOTE:
      return <Sidenote {...fields} />;

    case outgrowEnum.ARTICLE:
    case outgrowEnum.CUSTOM:
      return <OutgrowIframe {...fields} />;

    default:
      return null;
  }
}
